import { Energiattest, EnergyPlan } from '../../types/building';
import { Energimerke, Energimerkeversjon } from '../../types/energimerke';

export const fromEnergiplanToEnergimerke = (energiplan?: Partial<EnergyPlan>): Energimerke => ({
  energikarakter: energiplan?.energimerke?.energiKarakter,
  oppvarmingskarakter: energiplan?.energimerke?.properties?.oppvarmingKarakter,
  // Default to v2023 if version is not defined. This should probably be set in backend.
  version: energiplan?.energimerke?.properties?.energimerkeVersjon || Energimerkeversjon.V2023
});

//TODO: Update data structure delivered from backend. We should not derive version from oppvarmingsKarakter.
export const fromAttestToEnergimerke = (attest?: Energiattest) => ({
  energikarakter: attest?.energiKarakter,
  oppvarmingskarakter: attest?.oppvarmingKarakter,
  version: attest?.oppvarmingKarakter ? Energimerkeversjon.V2023 : Energimerkeversjon.V2025
});
